import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ExternalStats } from "src/app/models/external-stats";
import { ExternalViewStats } from "src/app/models/external-view-stats";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ExternalVideoService {

  private readonly http = inject(HttpClient);

  postExternalEmbeddedLinkStats(externalStatsModel: ExternalStats): Observable<void> {
    const url = `${environment.apiUrl}/records/statistics/generic`;
    return this.http.post<void>(url, externalStatsModel);
  }

  postExternalDatabaseViewStats(externalViewStats: ExternalViewStats): Observable<void> {
    const url = `${environment.apiUrl}/externals/stats`;
    return this.http.post<void>(url, externalViewStats);
  }

}